import { createApi } from "@reduxjs/toolkit/query/react";
import { EmailContent, EmailSummary } from "../../models/contentManager";
import { apiBaseQuery } from "../helpers";

const contentManagerApi = createApi({
  reducerPath: "contentManager",
  tagTypes: [],
  baseQuery: apiBaseQuery("/content"),
  endpoints: builder => ({
    getEmailSummary: builder.query<EmailSummary[], string>({
      query: conversationId => `/v2/messages/email/byconversationid/${conversationId}/summary`,
    }),
    getEmailContent: builder.query<EmailContent, string>({
      query: messageId => `/v2/messages/email/bymessageid?messageId=${messageId}`,
    }),
  }),
});

export const {
  useLazyGetEmailSummaryQuery,
  useLazyGetEmailContentQuery,
} = contentManagerApi;

export default contentManagerApi;
